import React from 'react';
import './JobSearchStartDateModal.css'; // Reuse the same styles

const DiscardConfirmModal = ({ isOpen, onClose, onConfirm, applicationName }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Discard Application?</h2>
        <p className="modal-description">
          Are you sure you want to discard this application?
        </p>
        
        {applicationName && (
          <div className="date-info" style={{ background: '#fff3cd', padding: '12px', borderRadius: '6px', border: '1px solid #ffc107' }}>
            <p style={{ margin: 0, color: '#856404' }}>
              <strong>{applicationName}</strong>
            </p>
          </div>
        )}

        <div className="date-info">
          <p style={{ color: '#dc3545', fontWeight: '500' }}>
            ⚠️ This action cannot be undone. The application will be permanently deleted.
          </p>
        </div>

        <div className="modal-actions">
          <button 
            onClick={onClose} 
            className="btn-secondary"
          >
            Cancel
          </button>
          <button 
            onClick={onConfirm} 
            className="btn-primary"
            style={{ background: '#dc3545' }}
          >
            Yes, Discard
          </button>
        </div>
      </div>
    </div>
  );
};

export default DiscardConfirmModal;

